import request from '@/utils/request'
const BASE_URL = '/Mall'

export default {
  categoryAll() {
    return request({
      url: BASE_URL + '/CategoryAll',
      method: 'get'
    })
  },
  categoryTree() {
    return request({
      url: BASE_URL + '/CategoryTree',
      method: 'get'
    })
  },
  categoryDetail(catId) {
    return request({
      url: BASE_URL + '/CategoryDetail',
      method: 'post',
      params: { catId }
    })
  }
}